import { parseQuery } from 'common/utils'

export const mapSearchToListState =
  (prefix = '') =>
  (search: string) => {
    const parsed = parseQuery(search)
    const listJson = prefix ? parsed[`${prefix}List`] : parsed.list
    return listJson ? JSON.parse(decodeURIComponent(listJson)) : {}
  }
